const orderTypeEnum = Object.freeze({
    DELIVERY: 5,
    PICK_UP: 10,
    POS: 15
});
export default orderTypeEnum;
